import { Extension, Node } from '@tiptap/core'
import Suggestion from '@tiptap/suggestion'
import { placeholderBadge } from './PlaceholderList.css'
import placeholderSuggestion from './suggestion'

export const PlaceholderNode = Node.create({
    name: 'placeholderNode',
    group: 'inline',
    inline: true,
    selectable: true,
    atom: true,

    addAttributes() {
        return {
            category: {
                default: null,
                parseHTML: element => element.getAttribute('data-category'),
                renderHTML: attributes => {
                    return {
                        'data-category': attributes.category,
                    }
                },
            },
            placeholder: {
                default: null,
                parseHTML: element => element.getAttribute('data-placeholder'),
                renderHTML: attributes => {
                    return {
                        'data-placeholder': attributes.placeholder,
                    }
                },
            },
            label: {
                default: null,
                parseHTML: element => element.getAttribute('data-label'),
                renderHTML: attributes => {
                    return { 'data-label': attributes.label }
                }
            }
        }
    },

    parseHTML() {
        return [
            {
                tag: 'span[data-placeholder-node]',
            },
        ]
    },

    renderHTML({ HTMLAttributes }) {
        return [
            'span',
            {
                'data-placeholder-node': '',
                'data-category': HTMLAttributes['data-category'],
                'data-placeholder': HTMLAttributes['data-placeholder'],
                'data-label': HTMLAttributes['data-label'],
                class: placeholderBadge,
            },
            HTMLAttributes['data-label']
        ]
    },

    addKeyboardShortcuts() {
        return {
            // Handle backspace to delete the entire placeholder when cursor is right after it
            Backspace: () => {
                const { selection, doc } = this.editor.state
                const { empty, anchor } = selection

                if (!empty) {
                    return false
                }

                const $pos = doc.resolve(anchor)
                const prevNode = $pos.nodeBefore

                if (prevNode && prevNode.type.name === this.name) {
                    // Delete the entire placeholder node
                    this.editor
                        .chain()
                        .focus()
                        .command(({ tr }) => {
                            tr.delete(anchor - prevNode.nodeSize, anchor)
                            return true
                        })
                        .run()

                    return true
                }

                return false
            }
        }
    }
})

// Placeholder extension bundle
export const addPlaceholderExtension = (placeholderCategories?: string[]) => Extension.create({
    name: 'placeholderSuggestionExtension',

    addOptions() {
        return {
            suggestion: {
                char: '/',
                ...placeholderSuggestion(placeholderCategories)
            },
        }
    },

    addProseMirrorPlugins() {
        return [
            Suggestion({
                editor: this.editor,
                ...this.options.suggestion
            })
        ]
    },

    addExtensions() {
        return [
            PlaceholderNode
        ]
    }
})
